import { useOutletContext } from "react-router-dom";
import { StyledCard } from "./styledCard";
import type { AccountEntity } from "@dealer-center/ddc-api-account-interface";
import {
  PagesLandingPageListItem,
  StyledUnorderedList
} from "@dealer-center/ddc-core-custom-components";
import { CardContent, CardHeader, Grid } from "@dealer-center/core-components";
import type { IDashboardProps } from "@dealer-center/ddc-pages-dashboard-interface";

export const DealerContact = (props: IDashboardProps) => {
  const { isEdit } = props;
  const { accountEntity } = useOutletContext<{
    accountEntity: AccountEntity;
  }>();

  return (
    <Grid size={!isEdit ? { lg: 3, sm: 6, xs: 12 } : 12}>
      <StyledCard
        content={
          <CardContent>
            <StyledUnorderedList>
              {accountEntity.primaryContactInformation.phoneNumbers.map(
                phoneNumber => (
                  <PagesLandingPageListItem
                    key={phoneNumber.type}
                    label={
                      phoneNumber.type.charAt(0).toUpperCase() +
                      phoneNumber.type.slice(1).toLowerCase()
                    }
                    type={isEdit ? "disabledInput" : undefined}
                    value={phoneNumber.number}
                  />
                )
              )}
              <PagesLandingPageListItem
                label="First Contact"
                type={isEdit ? "disabledInput" : "email"}
                value={accountEntity.primaryContactInformation.email}
              />
              <PagesLandingPageListItem
                label="Second Contact"
                type="email"
                value={accountEntity.primaryContactInformation.email2}
              />
              <PagesLandingPageListItem
                label="First Name"
                value={accountEntity.primaryContactInformation.firstName}
              />
              <PagesLandingPageListItem
                label="Last Name"
                value={accountEntity.primaryContactInformation.lastName}
              />
            </StyledUnorderedList>
          </CardContent>
        }
        header={<CardHeader title="Dealer Contact" />}
      />
    </Grid>
  );
};
